import { createContext, useContext } from "react";
import { masterAuth } from "../services/auth";
import useSession from "../hooks/useSession";

const MasterAuthContext = createContext(null);

export function MasterAuthProvider({ children }) {
  const { user, setUser, loading, error, retry } = useSession("bd_master_token", masterAuth.current);

  const login = async (email, password) => {
    const res = await masterAuth.login(email, password);
    localStorage.setItem("bd_master_token", res.data.access_token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("bd_master_token");
    setUser(null);
  };

  const has = (perm) => !!user?.permissions?.includes(perm);

  return (
    <MasterAuthContext.Provider value={{ user, loading, login, logout, has, error, retry }}>
      {children}
    </MasterAuthContext.Provider>
  );
}

export const useMasterAuth = () => useContext(MasterAuthContext);
